import { DataTable } from '../../../models';
import { DateWindowTypes } from '../core';

export enum SpecialDateWindowType {
  ALL_TIME = 'all-time',
}

export interface SpecialDateWindow {
  specialType: SpecialDateWindowType;
  type: DateWindowTypes.SPECIAL;
}

/**
 * As of 2022.2, we've renamed "All time" in the UI to "Max"
 */
export const ALL_TIME_DATE_WINDOW: SpecialDateWindow = {
  specialType: SpecialDateWindowType.ALL_TIME,
  type: DateWindowTypes.SPECIAL,
};

export const allTimeDateWindow = () => {
  return (table: DataTable) => table;
};

export const createSpecialWindow = (specialType: SpecialDateWindowType): SpecialDateWindow => {
  return {
    type: DateWindowTypes.SPECIAL,
    specialType,
  };
};
